import { KEY_REDUCER_PARAGRAPHS } from "./constants";

export const selectorParagraphs = (state) => state[KEY_REDUCER_PARAGRAPHS].paragraphs;
export const selectorBooksCacheInfo = (state) => state[KEY_REDUCER_PARAGRAPHS].booksCacheInfo;
export const selectorChaptersParas = (state) => state[KEY_REDUCER_PARAGRAPHS].chaptersParas;
